"use client";

import {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";

import CAgGrid from "./CAgGrid";
import CDropdown from "./CDropdown";

import { GetUserDetailsByRoleId } from "../services/userService";
import { GetInquiryDataByPunch } from "../services/inquiryService";

const CPunchRes = forwardRef(
  (
    {
      userId = null,
      punch = null,
      ringing = null,
      deny = null,
      columnDefs = [],
      h4 = "",
      IsAdmin = false,
  IsSales = false,
  IsPunch = false,
    },
    ref
  ) => {
    const [rowData, setRowData] = useState([]);
    const [loading, setLoading] = useState(false);

    const [users, setUsers] = useState([]);
    //const [errors, setErrors] = useState({});
    const [userPermissionRoleId, setUserPermissionRoleId] = useState(null);

    const [search, setSearch] = useState({
      userId,
      punch,
      ringing,
      deny,
    });

    const abortRef = useRef(null);

    useEffect(() => {
      if (typeof window !== "undefined") {
        setUserPermissionRoleId(
          Number(localStorage.getItem("userPermissionRoleId"))
        );
      }
    }, []);

    useEffect(() => {
      setSearch({
        userId,
        punch,
        ringing,
        deny,
      });
    }, [userId, punch, ringing, deny]);

    useEffect(() => {
      if (!userPermissionRoleId) return;

      const fetchUsers = async () => {
        try {
          const response = await GetUserDetailsByRoleId(
            userPermissionRoleId
          );

          if (response?.success) {
            setUsers(response.data || []);
          } else {
            setUsers([]);
          }
        } catch (err) {
          console.error(err);
          setUsers([]);
        }
      };

      fetchUsers();
    }, [userPermissionRoleId]);

    const defaultColDef = useMemo(
      () => ({
        flex: 1,
        sortable: true,
        filter: true,
        floatingFilter: true,
        resizable: true,
      }),
      []
    );

    const maskMobile = (mobile) => {
      if (!mobile) return "";
      mobile = mobile.toString();
      return `${mobile.slice(0, -2)}**`;
    };

    const mapOrders = useCallback((data = []) => {
      const hideMobile = data.length > 1;

      return data.map((item, index) => ({
        id: item.id,
        orderType:item.orderType,
        name: item.name,
        consultation: item.consultation,
        mobile:
          hideMobile && index !== 0
            ? maskMobile(item.mobile)
            : item.mobile,
        address: item.address,
        city: item.city,
        state: item.state,
        pinCode: item.pinCode,
        followUpSts: item.followUpSts,
        followUpDate: item.followUpDate,
        assignName: item.assignName,
        remarks: item.remarks,
        assignDate:item.assignDate,
      }));
    }, []);

    const fetchOrders = useCallback(async () => {
      try {
        abortRef.current?.abort();

        const controller = new AbortController();
        abortRef.current = controller;

        setLoading(true);
        const response = await GetInquiryDataByPunch(
           search.userId,
    search.punch,
    search.ringing,
    search.deny,
          {
            signal: controller.signal,
          }
        );

        if (response?.success) {
          setRowData(mapOrders(response.data || []));
        } else {
          setRowData([]);
        }
      } catch (error) {
        if (error.name !== "AbortError") {
          console.error(error);
          setRowData([]);
        }
      } finally {
        setLoading(false);
      }
    }, [search, mapOrders]);

    useEffect(() => {
      fetchOrders();

      return () => abortRef.current?.abort();
    }, [fetchOrders]);

    useImperativeHandle(ref, () => ({
      refresh: fetchOrders,
    }));

    const handleInputChange = (field, value) => {
      setSearch((prev) => ({
        ...prev,
        [field]: value,
      }));
    };

    const handleTeleCallerChange = (e) => {
      const value = e.target.value ? Number(e.target.value) : null;
      handleInputChange("userId", value);
    };

    return (
      <>
        <h4 className="mb-3">{h4}</h4>

        <div className="row g-3 mb-3">
          {IsAdmin && (
            <div className="col-md-3">
              <CDropdown
                label="Tele Caller Name"
                name="teleCallName"
                value={search.userId ?? ""}
                options={users}
                optionLabel="userName"
                optionValue="id"
                firstOption="Select Name"
                onChange={handleTeleCallerChange}
              />
            </div>
          )}

          {(IsAdmin || IsSales) && (
            <div className="col-md-3">
              <label className="form-label">User Id</label>

              <input
                type="number"
                className="form-control"
                value={search.userId ?? ""}
                readOnly
              />
            </div>
          )}
        </div>

        <div className="mb-3">
          <strong>Total Records:</strong> {rowData.length}
        </div>

        <CAgGrid
          rowData={rowData}
          columnDefs={columnDefs}
          loading={loading}
          defaultColDef={defaultColDef}
          pagination={true}
          paginationPageSize={10}
          rowSelection="multiple"
          height="450px"
        />
      </>
    );
  }
);

CPunchRes.displayName = "CPunchRes";

export default CPunchRes;